import type { FilterMapper } from '@/scopes/checkout/filterableCars/domain/types/filterMappers';
import type { MultiValueFilter } from '@/scopes/checkout/filterableCars/domain/types';
import type { APIFilterableCarFilter } from '@/scopes/checkout/filterableCars/infrastructure/api/types';

export const createMultiValueFilterMapper: () => FilterMapper<MultiValueFilter> = () => {
  function map(filtersFromApi: APIFilterableCarFilter) {
    if (!filtersFromApi || filtersFromApi.values.length === 0) return null;

    return {
      type: filtersFromApi.type,
      selectedFilters: mapSelectedFilters(filtersFromApi),
      filterOptions: filtersFromApi.values.map((value) => ({
        name: value.name,
        value: value.value,
        quantity: value.quantity,
        startingPrice: value.startingPrice,
      })),
    };
  }

  function mapSelectedFilters(filtersFromApi: APIFilterableCarFilter) {
    return filtersFromApi.values.filter((value) => value.isSelected).map((value) => value.value);
  }

  function mapSelection(filter: MultiValueFilter) {
    const { filterOptions, selectedFilters } = filter;

    return filterOptions.map((option) => {
      return {
        value: option.value,
        name: option.name,
        selected: selectedFilters.includes(option.value),
      };
    });
  }
  return {
    map,
    mapSelection,
  };
};
